import React, { ReactNode } from "react";
import styled from "styled-components";
import { primaryColor } from "../colors";
import { mobileQuery } from "../MediaQuery";
import { ResponsiveLayout } from "../ResponsiveLayout";
import { SizedBox } from "../SizedBox";
import { Header2 } from "../typography";
import { Section } from "./Section";

export const MainSection: React.FC = () => (
  <Section>
    <SizedBox height={44} />
    <ResponsiveLayout
      justifyContent="space-evenly"
      alignItems="center"
      flexDirection="column"
    >
      <ItemBox
        content={
          <div>
            <WebHealthAdvisorHuge>170 000+</WebHealthAdvisorHuge>
            <WebHealthAdvisorSmall>users</WebHealthAdvisorSmall>
            <SizedBox height={32} />
            <Header2 color={primaryColor} center>
              Web Health Advisor
            </Header2>
          </div>
        }
        image="web-health-advisor.jpg"
        subtitle="Connect &amp; Acquire customers"
        reverse
      />
      <ItemBox
        content={
          <Header2 color={primaryColor} center>
            Health Tracker Module
          </Header2>
        }
        image="tracker-module.jpg"
        subtitle="Boost Engagement, NPS &amp; Retention of your App"
      />
      <ItemBox
        content={
          <div>
            <Header2 color={primaryColor} center>
              Health game &amp; app
            </Header2>
            <SizedBox height={32} />
            <ResponsiveLayout justifyContent="center" alignItems="center">
              <img
                style={{ height: 60 }}
                src={`/insurers/main/google-fit.png`}
              />
              <SizedBox width={16} mobileHeight={16} />
              <img
                style={{ height: 60 }}
                src={`/insurers/main/apple-health.png`}
              />
            </ResponsiveLayout>
            <SizedBox height={16} />
            <ResponsiveLayout justifyContent="center" alignItems="center">
              <img style={{ height: 72 }} src={`/insurers/main/rating.png`} />
            </ResponsiveLayout>
          </div>
        }
        image="app.jpg"
        subtitle="Connect, Engage, Increase Healthspan"
        reverse
      />
    </ResponsiveLayout>
  </Section>
);

const ItemBox: React.FC<{
  image: string;
  content: ReactNode;
  subtitle: string;
  reverse?: boolean;
}> = (props) => (
  <ItemBoxWrapper reverse={props.reverse ?? false}>
    <ItemImage src={`/insurers/main/${props.image}`} />
    <div>
      {props.content}
      <ItemSubtitle>{props.subtitle}</ItemSubtitle>
    </div>
  </ItemBoxWrapper>
);

const ItemBoxWrapper = styled.div<{ reverse: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  justify-content: space-between;
  margin-left: 150px;
  margin-right: 150px;

  ${mobileQuery`
    margin-bottom: 48px;
    flex-direction: column-reverse;
  `}
`;

const ItemImage = styled.img`
  width: 300px;
  height: 613px;
`;

const ItemSubtitle = styled.p`
  color: white;
  font-size: 36px;
  font-weight: medium;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 20px;
  margin-left: 20px;
  background: linear-gradient(
    90deg,
    rgba(190, 75, 219, 1) 0%,
    rgba(76, 110, 245, 1) 60%
  );
  ${mobileQuery`
    font-size: 18px;
  `}
`;

const WebHealthAdvisorHuge = styled.p`
  color: ${primaryColor};
  font-weight: 800;
  font-size: 96px;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 0px;
  ${mobileQuery`
    font-size: 48px;
  `}
`;

const WebHealthAdvisorSmall = styled.p`
  color: ${primaryColor};
  font-weight: 700;
  font-size: 48px;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 0px;
  ${mobileQuery`
    font-size: 24px;
  `}
`;
